import { AppType, APP_TYPE } from "../../app.type";
import { Inject, Injectable } from "@angular/core";
import { FilterDashboardServiceType } from "./filter-dashboard.service.type";
import { DashboardFilters } from "../../../../../shared/models/dashboard";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class FilterDashboardService implements FilterDashboardServiceType {
  isOpen = false;
  filters: DashboardFilters = new DashboardFilters();
  enableReset = false;
  createTimeFilters: { startDate: number; endDate: number } = {
    startDate: 0,
    endDate: 0,
  };

  onFilterChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  getSelectedFilters() {
    if (this.createTimeFilters.startDate != null) {
      this.filters.createTimeStart = this.createTimeFilters.startDate;
    }
    if (this.createTimeFilters.endDate != null) {
      this.filters.createTimeEnd = this.createTimeFilters.endDate;
    }

    this.onFilterChange.next(true);
  }

  isCreateTimeFilterDisabled() {
    if (
      this.createTimeFilters.startDate > 0 &&
      this.createTimeFilters.endDate > 0
    ) {
      return false;
    }
    return true;
  }

  resetFilter(shouldTriggerApi: boolean) {
    this.createTimeFilters = {
      startDate: 0,
      endDate: 0,
    };
    this.filters = new DashboardFilters();
    this.onFilterChange.next(shouldTriggerApi);
    this.enableReset = false;
  }
}
